import { render, staticRenderFns } from "./listitems.vue?vue&type=template&id=71c31e36&scoped=true"
import script from "./listitems.vue?vue&type=script&lang=js"
export * from "./listitems.vue?vue&type=script&lang=js"
import style0 from "./listitems.vue?vue&type=style&index=0&id=71c31e36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c31e36",
  null
  
)

export default component.exports